import Network from './network';
/**
 * 首页 接口管理home/getHomeKaiwaSectionChartData
 */
let httpFalse = true
// if(httpFalse){

const usersCount = (data) => Network.post('servicesapitest/users/count',
  data);
const servicesapitest_projectInfo_getAllNodeTree = (data) => Network.get('servicesapitest/projectInfo/getAllNodeTree',
  data);

const kaiWaSectionInfoFromProject = (data) => Network.post('home/getHomeKaiwaSectionChartData', data);
const initSectionInfoFromProject = (data) => Network.post('home/getHomeInitSectionChartData', data);
const secSectionInfoFromProject = (data) => Network.post('home/getHomeSecSectionChartData', data);
const initDKCHaoQianWaInfo = (data) => Network.post('home/getInitDKCHaoQianWaInfo', data);
const kaiwaDKCHaoQianWaInfo = (data) => Network.post('home/getKWDKCHaoQianWaInfo', data);
const secDKCHaoQianWaInfo = (data) => Network.post('home/getSecDKCHaoQianWaInfo', data);
const KWDKCountAndUnqualifiedCount = (data) => Network.post('home/getKWDKCountAndUnqualifiedCount', data);
const initDKCountAndUnqualifiedCount = (data) => Network.post('home/getInitDKCountAndUnqualifiedCount', data);
const secDKCountAndUnqualifiedCount = (data) => Network.post('home/getSecDKCountAndUnqualifiedCount', data);
const initUnqualifiedPoint = (data) => Network.post('home/getInitUnqualifiedPoint', data);
const KWUnqualifiedPoint = (data) => Network.post('home/getKWUnqualifiedPoint', data);
const secUnqualifiedPoint = (data) => Network.post('home/getSecUnqualifiedPoint', data);
const projectLevelData = (data) => Network.post('home/getProjectLevelData', data);
const sectionLevelData = (data) => Network.post('home/getSectionLevelData', data);
const buildLevelData = (data) => Network.post('home/getBuildLevelData', data);
const initProjectSiteLevelData = (data) => Network.get('home/getInitProjectSiteLevelData', data);
const KWProjectSiteLevelData = (data) => Network.get('home/getKWProjectSiteLevelData', data);
const secProjectSiteLevelData = (data) => Network.get('home/getSecProjectSiteLevelData', data);


const getUserByLoginAccount = (data) => Network.get('servicesapitest/users/getUserByLoginAccount', data);
const initDKLeng = (data) => Network.post('home/getInitDKLength', data);
const KWDKLeng = (data) => Network.post('home/getKWDKLength', data);
const secDKLeng = (data) => Network.post('home/getSecDKLength', data);
const initScanLengthRatio = (data) => Network.post('home/getInitScanLengthRatio', data);
const KWScanLengthRatio = (data) => Network.post('home/getKWScanLengthRatio', data);
const secScanLengthRatio = (data) => Network.post('home/getSecScanLengthRatio', data);

const initPlcInfo = (data) => Network.postJson('ChaoQianWa/getInitPclInfo?projectSiteId=' + data.projectSiteId, data);
const kaiwaPlcInfo = (data) => Network.postJson('ChaoQianWa/getKWPclInfo?projectSiteId=' + data.projectSiteId, data);
const secPlcInfo = (data) => Network.postJson('ChaoQianWa/getSecPclInfo?projectSiteId=' + data.projectSiteId, data);





/**
 * 断面详情 接口管理
 */
const initDKDetail = (data) => Network.post('home/getInitDKDetail?id=' + data.id, {});
const KWDKDetail = (data) => Network.post('home/getKWDKDetail?id=' + data.id, {});
const secDKDetail = (data) => Network.post('home/getSecDKDetail?id=' + data.id, {});
const initDKDetailPoints = (data) => Network.post('home/getInitDKDetailPoints?id=' + data.id, {});
const KWDKDetailPoints = (data) => Network.post('home/getKWDKDetailPoints?id=' + data.id, {});
const secDKDetailPoints = (data) => Network.post('home/getSecDKDetailPoints?id=' + data.id, {});
const projectInfoById = (data) => Network.get('servicesapitest/projectInfo/getProjectInfoById?id=' + data.id, {});
const projectSectionById = (data) => Network.get('servicesapitest/projectSection/getProjectSectionById?id=' + data
  .id, {});
const initCloudPoint = (data) => Network.post('ChaoQianWa/getInitPclByProjectSiteId?id=' + data.id, {});
const kaiwaCloudPoint = (data) => Network.post('ChaoQianWa/getKWPclByProjectSiteId?id=' + data.id, {});
const secCloudPoint = (data) => Network.post('ChaoQianWa/getSecPclByProjectSiteId?id=' + data.id, {});
/**ChaoQianWa/getSecPclByProjectSiteId
 * 设备界面接口管理
 *
 * 设备查询
 * ?buildId='+ data.buildId + '&projectId=' + data.projectId + '&projectsiteId=' + data.projectSiteId + '&sectionId=' + data.sectionId
 */
const deviceAdd = (data) => Network.upload('equipment/add', data);
const deviceEdit = (data) => Network.upload('equipment/update', data);
const deviceDelete = (data) => Network.post('equipment/delete', data);
const deviceQuery = (data) => Network.get('equipment/queryListPage', data);
const equipmentTypeList = (data) => Network.post('equipment/getEquipmentTypeList', data);
const checkRecordById = (data) => Network.post('equipment/getCheckRecordById?equipmentId=' + data.equipmentId, data);
const addNotFile = (data) => Network.post('equipment/addNotFile', data);
const updateNotFile = (data) => Network.post('equipment/updateNotFile', data);
/**
 * 超欠挖接口管理
 * + '&handleState=' + data.handleState
 *
 * 超欠挖数据 拼接
 * ?buildId='+ data.buildId + '&projectId=' + data.projectId + '&projectsiteId=' + data.projectSiteId + '&sectionId=' + data.sectionId
 * ?buildId='+ data.buildId + '&projectId=' + data.projectId + '&projectsiteId=' + data.projectSiteId + '&sectionId=' + data.sectionId + '&handleState=' + data.handleState
 *
 * getInitDKHandleCount
 * ?buildId='+ data.buildId + '&projectId=' + data.projectId + '&projectsiteId=' + data.projectSiteId + '&sectionId=' + data.sectionId
 */
const KaiWaChaoQianWaData = (data) => Network.get('ChaoQianWa/getKaiWaChaoQianWa', data);
const initChaoQianWaData = (data) => Network.get('ChaoQianWa/getInitChaoQianWa', data);
const secChaoQianWaData = (data) => Network.get('ChaoQianWa/getSecChaoQianWa', data);

const initDKHandleCount = (data) => Network.post('ChaoQianWa/getInitDKHandleCount', data);
const kaiWaDKHandleCount = (data) => Network.post('ChaoQianWa/getKaiWaDKHandleCount', data);
const secDKHandleCount = (data) => Network.post('ChaoQianWa/getSecDKHandleCount', data);

const initDKHandleTime = (data) => Network.post("ChaoQianWa/getInitDKHandleTime", data);
const kaiWaHandleTime = (data) => Network.post("ChaoQianWa/getKaiWaHandleTime", data);
const secDKHandleTime = (data) => Network.post("ChaoQianWa/getSecDKHandleTime", data);

const initDkHandle = (data) => Network.upload("ChaoQianWa/initDkHandle", data);
const kaiwaDkHandle = (data) => Network.upload("ChaoQianWa/kaiwaDkHandle", data);
const secDkHandle = (data) => Network.upload("ChaoQianWa/secDkHandle", data);
const batchKaiWaDkHandle = (data) => Network.post("ChaoQianWa/batchKaiWaDkHandle", data);
const batchInitDkHandle = (data) => Network.post("ChaoQianWa/batchInitDkHandle", data);
const batchSecDkHandle = (data) => Network.post("ChaoQianWa/batchSecDkHandle", data);
const batchKaiWaDkHandleClose = (data) => Network.post("ChaoQianWa/batchKaiWaDkHandleClose", data);
const batchInitDkHandleClose = (data) => Network.post("ChaoQianWa/batchInitDkHandleClose", data);
const batchSecDkHandleClose = (data) => Network.post("ChaoQianWa/batchSecDkHandleClose", data);
const getInitFilesById = (data) => Network.post("ChaoQianWa/getInitFilesById?id=" + data.id, {});
const getKaiWaFilesById = (data) => Network.post("ChaoQianWa/getKaiWaFilesById?id=" + data.id, {});
const getSecFilesById = (data) => Network.post("ChaoQianWa/getSecFilesById?id=" + data.id, {});
const initSectionPoint = (data) => Network.get("initSectionPoint/queryListPage", data);
const kaiwaSectionPoint = (data) => Network.get("kaiwaSectionPoint/queryListPage", data);
const secSectionPoint = (data) => Network.get("secSectionPoint/queryListPage", data);
const chaoxianReviewList = (data) => Network.post("ChaoQianWa/getChaoxianReviewList", data);



/**
 * 设置界面接口
 *
 *
 */
const addKaiWaSetting = (data) => Network.post("Setting/addKaiWaSetting", data);
const addInitSetting = (data) => Network.post("Setting/addInitSetting", data);
const addSecSetting = (data) => Network.post("Setting/addSecSetting", data);
const queryKaiWaPage = (data) => Network.get("Setting/queryKaiWaPage", data);
const queryInitPage = (data) => Network.get("Setting/queryInitPage", data);
const querySecPage = (data) => Network.get("Setting/querySecPage", data);
const updateKaiWaSetting = (data) => Network.post("Setting/updateKaiWaSetting", data);
const updateInitSetting = (data) => Network.post("Setting/updateInitSetting", data);
const updateSecSetting = (data) => Network.post("Setting/updateSecSetting", data);
const projectsiteInfo = (data) => Network.get("projectsite/projectsite?id=" + data.id, {});
const buildById = (data) => Network.get("servicesapitest/build?id=" + data.id, {});
const projectsiteById = (data) => Network.get("projectsite/projectsite?id=" + data.id, {});
const addInitSettingAndFile = (data) => Network.upload('Setting/addInitSettingAndFile', data);
const addSecSettingAndFile = (data) => Network.upload('Setting/addSecSettingAndFile', data);
const addKWSettingAndFile = (data) => Network.upload('Setting/addKWSettingAndFile', data);
const initSettingFilesById = (data) => Network.post("Setting/getInitSettingFilesById?id=" + data.id, {});
const KWSettingFilesById = (data) => Network.post("Setting/getKWSettingFilesById?id=" + data.id, {});
const secSettingFilesById = (data) => Network.post("Setting/getSecSettingFilesById?id=" + data.id, {});
const updateInitSettingAndFile = (data) => Network.upload("Setting/updateInitSetting", data);
const updateKaiWaSettingAndFile = (data) => Network.upload("Setting/updateKaiWaSetting", data);
const updateSecSettingAndFile = (data) => Network.upload("Setting/updateSecSetting", data);

const deleteInitSettingFile = (data) => Network.post("Setting/deleteInitSettingFile?fileId=" + data.id, {});
const deleteKWSettingFile = (data) => Network.post("Setting/deleteKWSettingFile?fileId=" + data.id, {});
const deleteSecSettingFile = (data) => Network.post("Setting/deleteSecSettingFile?fileId=" + data.id, {});
const settingReviewList = (data) => Network.post("Setting/getSettingReviewList", data);
const downloadInitSettingFilesById = (data) => Network.get("Setting/downloadInitSettingFilesById?fileId=" + data
  .fileId + '&type=' + data.type, {});







/**
 * 工程树
 */

const getProjectinfoByUserId = (data) => Network.get('servicesapitest/users/getProjectinfoByUserId', {});
const sectionListByProjectId = (data) => Network.post(
  'servicesapitest/users/getProjectSectionByProjectIdAndUserId?userId=' + data.userId + '&projectId=' + data
  .projectId, {});
const getBuildList = (data) => Network.post('servicesapitest/users/getBuildListByProjectSectionIdAndUserId?userId=' +
  data.userId + '&projectSectionId=' + data.sectionId, {});
const getProjectSiteListById = (data) => Network.post('servicesapitest/users/getSiteListByBuildIdAndUserId?userId=' +
  data.userId + '&buildId=' + data.buildId, {});

const buildByUserId = (data) => Network.post('servicesapitest/users/getBuildByUserId?userId=' + data.userId, {});
const projectSiteByUserId = (data) => Network.post('servicesapitest/users/getProjectSiteByUserId?userId=' + data
.userId, {});
const getProjectSectionByUserId = (data) => Network.post(
  'servicesapitest/users/getProjectSectionByProjectIdAndUserId?userId=' + data.userId + '&projectId=' + data
  .projectId, {});

const sectionListByProjectIdAndUserId = (data) => Network.post(
  "servicesapitest/users/getProjectSectionByProjectIdAndUserId?projectId=" + data.projectId + '&userId=' + data
  .userId, data)


/**
 * 用户角色
 *
 *
 *
 */
const decryptByAes = (data) => Network.get('servicesapitest/users/decryptByAes', data);
const roleByLoginAccount = (data) => Network.post("servicesapitest/users/getRoleByLoginAccount?account=" + data
.account, {});
const projectAndSectionTree = (data) => Network.post("servicesapitest/users/getProjectAndSectionTree", {});
const getRoleList = (data) => Network.post("servicesapitest/users/getRoleList", {});
const userList = (data) => Network.post("servicesapitest/users/queryListByAdmin", data);
const roleUpdate = (data) => Network.post("servicesapitest/users/update", data);
const setProjectAndSectionPer = (data) => Network.post("servicesapitest/users/setProjectAndSectionPer", data);
const userAdd = (data) => Network.post("servicesapitest/users/add", data);
const userListSuper = (data) => Network.get('servicesapitest/users/queryListPage', {});
const queryProjectSiteListByAdmin = (data) => Network.post('servicesapitest/users/queryProjectSiteListByAdmin', data);
const getUserInfoById = (data) => Network.get('servicesapitest/users/getUserById', data);
const users_tokenToUser = (data) => Network.post('servicesapitest/users/tokenToUser?token=' + data.token, data)
// ?userId='+ data.id
/**
 * 消息
 */
const homeMessage = (data) => Network.post("homeMessage/GetHomeMessage?loginAccount=" + data.loginAccount, {});
// }

/* 衬砌厚度阈值  */
const addkaiwaAndPenmaoSetting = (data) => Network.upload('kaiwaAndPenmaoSetting/add', data)
const addPenmaoAndChenqiSetting = (data) => Network.upload('penmaoAndChenqiSetting/addPCSettingAndFile', data)
const getkaiwaAndPenmaoList = (data) => Network.get('kaiwaAndPenmaoSetting/queryListPage', data)
const getPenmaoAndChenqiList = (data) => Network.get('penmaoAndChenqiSetting/queryPMandCQPage', data)
const kaiwaAndPenmaoEdit = (data) => Network.upload('kaiwaAndPenmaoSetting/updateKWAndPMSetting', data)
const penmaoAndChenqiEdit = (data) => Network.upload('penmaoAndChenqiSetting/update', data)
const kaiwaAndPenmaoFileList = (data) => Network.post('kaiwaAndPenmaoSetting/KWandPMSettingFilesById?id=' + data.id,
  data)
const penmaoAndChenQiFileList = (data) => Network.post('penmaoAndChenqiSetting/getPMandCQSettingFilesById?id=' + data
  .id, data)
const kaiwaAndPenmaoFileDelete = (data) => Network.post('kaiwaAndPenmaoSetting/deleteKWandPMSettingFile?fileId=' + data
  .fileId, {})
const penmaoAndChenqiFileDelete = (data) => Network.post('penmaoAndChenqiSetting/deletePMandCQfile?fileId=' + data
  .fileId, {})
const penmaoAndChenqiCheckList = (data) => Network.post('penmaoAndChenqiSetting/getStateList', data)
const kaiwaAndPenmaoCheckList = (data) => Network.post('kaiwaAndPenmaoSetting/queryDetail', data)

/* 衬砌厚度 */
const KWPMDKlength = (data) => Network.post('kaiwaAndPenmaoSection/getKWPMDKLength', data)
const KWPMUnqualifiedPoint = (data) => Network.post('kaiwaAndPenmaoSection/getKWPMUnqualifiedPoint', data)
const KWPMliningLevelDataForProject = (data) => Network.post('kaiwaAndPenmaoSection/getProjectLevelData', data)
const KWPMliningLevelDataForSection = (data) => Network.post('kaiwaAndPenmaoSection/getSectionKwAndPmData', data)
const KWPMliningLevelDataForBuild = (data) => Network.post('kaiwaAndPenmaoSection/getBuildKwAndPmData', data)
const KWPMliningLevelDataForProjectSitePage = (data) => Network.get('kaiwaAndPenmaoSection/getKWPMProjectSiteLevelData',
  data)
const KWPMLevelDataForProjectSiteLine = (data) => Network.post('kaiwaAndPenmaoSection/pageKWPMProjectSiteLevelData',
  data)

const PMCQDKlength = (data) => Network.post('penmaoAndChenqiSection/getCQDKLength', data)
const PMCQUnqualifiedPoint = (data) => Network.post('penmaoAndChenqiSection/getPMCQDKLength', data)
const PMCQliningLevelDataForProject = (data) => Network.post('penmaoAndChenqiSection/getProjectLevelData', data)
const PMCQliningLevelDataForSection = (data) => Network.post('penmaoAndChenqiSection/getSectionPmAndCqData', data)
const PMCQliningLevelDataForBuild = (data) => Network.post('penmaoAndChenqiSection/getBuildPmAndCqData', data)
const PMCQliningLevelDataForProjectSitePage = (data) => Network.get(
  'penmaoAndChenqiSection/getPMCQProjectSiteLevelData', data)
const PMCQLevelDataForProjectSiteLine = (data) => Network.post('penmaoAndChenqiSection/PMCQProjectSiteLevelData', data)


/* 处理衬砌厚度 */
const KWPMPointList = (data) => Network.get('kaiwaAndPenmaoSectionPoint/getPenMaoUnqualified', data)
const KWPMPointEdit = (data) => Network.upload('kaiwaAndPenmaoSectionPoint/penMaoDkHandle', data)
const KWPMPointFileList = (data) => Network.post('kaiwaAndPenmaoSectionPoint/getPenMaoFilesById?id=' + data.id, data)
const KWPMPointCheckList = (data) => Network.post('kaiwaAndPenmaoSectionPoint/getPenMaoUnqualifiedReviewList', data)

const PMCQPointList = (data) => Network.get('penmaoAndChenqiSectionPoint/getChenQiChaoXianPoint', data)
const PMCQPointFileList = (data) => Network.post('penmaoAndChenqiSectionPoint/getChenqiFilesById?id=' + data.id, data)
const PMCQPointEdit = (data) => Network.upload('penmaoAndChenqiSectionPoint/chenQiUnqualifiedHandle', data)
const PMCQPointCheckList = (data) => Network.post('penmaoAndChenqiSectionPoint/getChaoxianReviewList', data)

/* 衬砌厚度断面 */
const KWPMSurfaceDetail = (data) => Network.post('kaiwaAndPenmaoSection/getPMDKDetail?id=' + data.id, data)
const PMCQSurfaceDetail = (data) => Network.post('penmaoAndChenqiSection/getPmAndCqDKDetail?id=' + data.id, data)
const PMCQSurfacePointList = (data) => Network.post('penmaoAndChenqiSection/getPmAndCqDKDetailPoints?id=' + data.id,
  data)
const KWPMSurfacePointList = (data) => Network.post('kaiwaAndPenmaoSection/getPMDKDetailPoints?id=' + data.id, data)
const getCrbimuid = (data) => Network.get('servicesapitest/users/checkUserInfo', data)


// 人员授权

const addAccount = (data) => Network.post('auth/addAccount', data)
const authUserList = (data) => Network.post('auth/getUserList', data)
const getPermissTree = (data) => Network.post('auth/getProjectTree?loginUserId=' + data.loginUserId + '&account=' + data
  .account, {});
const getAccountResource = (data) => Network.post('auth/getAccountResource?userId=' + data.userId, {});
const saveAccountResource = (data) => Network.post('auth/saveAccountResource', data);
const authUserDelete = (data) => Network.post('auth/deleteAccount?userId=' + data.userId, data);

/**
 *登录
 *date：2022-5-13
 auther：lenn
 */
const users_login = (data) => Network.post('servicesapitest/users/login', data);
/**
 * 方量
 * date:2022-5-13
 * auther:lenn
 */

const volume_queryProjectVolumePage = (data) => Network.get('volume/queryProjectVolumePage', data)
const volume_queryProjectSectionVolumePage = (data) => Network.get('volume/queryProjectSectionVolumePage', data)
const volume_queryBuildVolumePage = (data) => Network.get('volume/queryBuildVolumePage', data)
const volume_queryProjectSiteVolumePage = (data) => Network.get('volume/queryProjectSiteVolumePage', data)
const volume_compareTrend = (data) => Network.post('volume/compareTrend', data)
const volume_batchUpdate = (data) => Network.post('volume/batchMerge', data)
const volume_editVolume = (data) => Network.post('volume/editVolume', data)
const volume_createChenqiNumber = (data) => Network.post('volume/createChenqiNumber?projectSiteId=' + data
  .projectSiteId, data)
/**
 * 平整度
 * date:2022-5-13
 * auther:lenn
 */

const planeness_queryProjectPlanenessListPage = (data) => Network.get('planeness/queryProjectPlanenessListPage', data)
const planeness_queryProjectSectionPlanenessListPage = (data) => Network.get(
  'planeness/queryProjectSectionPlanenessListPage', data)
const planeness_queryBuildPlanenessListPage = (data) => Network.get('planeness/queryBuildPlanenessListPage', data)
const planeness_queryProjectSitePlanenessListPage = (data) => Network.get('planeness/queryProjectSitePlanenessListPage',
  data)
const planeness_queryProjectPlanenessScan = (data) => Network.get('planeness/queryProjectPlanenessScan', data)
const planeness_queryProjectSectionPlanenessScan = (data) => Network.get('planeness/queryProjectSectionPlanenessScan',
  data)
const planeness_queryBuildPlanenessScan = (data) => Network.get('planeness/queryBuildPlanenessScan', data)
// 项目数据导入
const batchImportProjectInfo = (data) => Network.postJson('servicesapitest/projectInfo/batchImportProjectInfo', data)
// 标段数据导入
const batchImportProjectSectionInfo = (data) => Network.postJson(
  'servicesapitest/projectSection/batchImportProjectSectionInfo', data)
// 工点数据导入
const batchImportProjectSite = (data) => Network.postJson('projectsite/batchImportProjectSite', data)
/**
 * 人员管理
 * date:2022-5-13
 * auther:lyy
 */
const personList = (data) => Network.get('servicesapitest/users/getUserListPage', data)
const personAdd = (data) => Network.post('servicesapitest/users/addUser', data)

const projectList = (data) => Network.get('servicesapitest/users/getProjectinfoByUserId', data)
const sectionList = (data) => Network.post('servicesapitest/users/getProjectSectionByProjectIdAndUserId?projectId=' +
  data.projectId + "&userId=" + data.userId, data)
const buildList = (data) => Network.post(
  'servicesapitest/users/getBuildListByProjectSectionIdAndUserId?projectSectionId=' + data.projectSectionId +
  "&userId=" + data.userId, data)
const siteList = (data) => Network.post('servicesapitest/users/getSiteListByBuildIdAndUserId?buildId=' + data.buildId +
  "&userId=" + data.userId, data)
const assignedSiteList = (data) => Network.post('servicesapitest/users/getAccountResource?userId=' + data.userId,
  data) //已分配
const assignSiteList = (data) => Network.post('servicesapitest/users/saveAccountResource', data) //分配

const passwordReset = (data) => Network.post('servicesapitest/users/resetPassword', data)
const delectPerson = (data) => Network.post('servicesapitest/users/delete?userId=' + data.userId, data)

// 喷锚断面与衬砌断面的厚度阈值设置下载附件
const downloadCQSettingFilesById = (data) => Network.get('penmaoAndChenqiSetting/downloadCQSettingFilesById?fileId=' +
  data.fileId, data)
// 开挖断面与喷锚断面的厚度阈值设置下载附件
const downloadPMSettingFilesById = (data) => Network.get('kaiwaAndPenmaoSetting/downloadPMSettingFilesById?fileId=' +
  data.fileId, data)
// 超限点下载附件
const downloadChaoXianFilesById = (data) => Network.get('ChaoQianWa/downloadChaoXianFilesById?fileId=' + data.fileId,
  data)

/**
 * 平整度阈值
 * date:2022-5-24
 * auther:lenn
 */

const planenessSetting_queryPlanenessSettingPage = (data) => Network.get('planenessSetting/queryPlanenessSettingPage',
  data)
const planenessSetting_addPlanenessSettingAndFile = (data) => Network.post(
  'planenessSetting/addPlanenessSettingAndFile', data)
const planenessSetting_updatePlanenessSetting = (data) => Network.post('planenessSetting/updatePlanenessSetting', data)
const planenessSetting_getPlanenessSettingFilesById = (data) => Network.post(
  'planenessSetting/getPlanenessSettingFilesById?id=' + data.id, data)
const planenessSetting_deleteInitSettingFile = (data) => Network.post(
  'planenessSetting/deletePlanenessSettingFile?fileId=' + data.fileId, data)

/**
 * 平整度问题处理
 * date:2022-5-24
 * auther:lenn
 */
const planenessProblem_queryPlanenessProblemPage = (data) => Network.get('planenessProblem/queryPlanenessProblemPage',
  data)
const planenessProblem_planenessProblemHandle = (data) => Network.post('planenessProblem/planenessProblemHandle', data)
const planenessProblem_queryPlanenessProblemFileList = (data) => Network.post(
  'planenessProblem/queryPlanenessProblemFileList?id=' + data.id, data)
const planenessProblem_deletePlanenessProblemFile = (data) => Network.post(
  'planenessProblem/deletePlanenessProblemFile?fileId=' + data.fileId, data)
const planenessProblem_queryPlanenessProblemReviewList = (data) => Network.post(
  'planenessProblem/queryPlanenessProblemReviewList', data)
/**
 * 方量阈值
 * date:2022-5-23
 * auther:lyy
 */
const volumeSetList = (data) => Network.get('volumeSetting/queryVolumeSettingPage', data)
const volumeSetDownload = (data) => Network.get('volumeSetting/downloadFilesById', data)
const volumeSetAdd = (data) => Network.post('volumeSetting/addVolumeSetting', data)
const volumeSetFileAdd = (data) => Network.post('volumeSetting/addVolumeSettingAndFile', data)
const volumeSetFileDelete = (data) => Network.post('volumeSetting//deleteVolumeSettingFile?fileId=' + data.fileId, data)
const volumeSetFileList = (data) => Network.post('volumeSetting/getVolumeSettingFilesById?id=' + data.id, data)
const volumeSetUpdate = (data) => Network.post('volumeSetting/updateVolumeSetting', data)
const volumeUpdateVolumeSetting = (data) => Network.post('volumeSetting/updateSettingValue', data)

/**
 * 方量问题处理
 * date:2022-5-24
 * auther:lyy
 */
const volumeProblemList = (data) => Network.get('volumeProblem/queryVolumeProblemPage', data)
const volumeProblemCheckList = (data) => Network.post('volumeProblem/queryVolumeProblemReviewList', data)
const volumeProblemHandle = (data) => Network.post('volumeProblem/volumeProblemHandle', data)
const volumeProblemFileList = (data) => Network.post('volumeProblem/queryVolumeProblemFileList?id=' + data.id, data)
const volumeProblemFileDelete = (data) => Network.post('volumeProblem/deleteVolumeProblemFile?fileId=' + data.fileId,
  data)
const volumeProblemDownload = (data) => Network.get('volumeProblem/downloadFilesById', data)


/**
 * 各阈值删除
 * date:2022-5-30
 * auther:lenn
 */
const kaiwaAndPenmaoSetting_deleteKWAndPMSetting = (data) => Network.post('kaiwaAndPenmaoSetting/deleteKWAndPMSetting',
  data)
const penmaoAndChenqiSetting_deletePMAndCQSetting = (data) => Network.post(
  'penmaoAndChenqiSetting/deletePMAndCQSetting', data)
const Setting_deleteKaiWaSetting = (data) => Network.post('Setting/deleteKaiWaSetting', data)
const Setting_deleteInitSetting = (data) => Network.post('Setting/deleteInitSetting', data)
const Setting_deleteSecSetting = (data) => Network.post('Setting/deleteSecSetting', data)
const volumeSetting_deleteVolumeSetting = (data) => Network.post('volumeSetting/deleteVolumeSetting', data)
const planenessSetting_deletePlanenessSetting = (data) => Network.post('planenessSetting/deletePlanenessSetting', data)

/*
  考核模块
  auther:sq
*/
const czPlanenessStatistics = (data) => Network.post('cZPlaneness/statistics', data)
const getVolumeScanProgress = (data) => Network.post('volumeCheck/getVolumeScanProgress', data)
const volumeCheckExportWord = (data) => Network.exportHaily('volumeCheck/exportWord', data)
const cZPlanenessExportWord = (data) => Network.exportHaily('cZPlaneness/export', data)


export {

  // 首页
  servicesapitest_projectInfo_getAllNodeTree,
  usersCount,

  decryptByAes,
  kaiWaSectionInfoFromProject,
  initSectionInfoFromProject,
  secSectionInfoFromProject,
  initDKCHaoQianWaInfo,
  kaiwaDKCHaoQianWaInfo,
  secDKCHaoQianWaInfo,
  initDKCountAndUnqualifiedCount,
  KWDKCountAndUnqualifiedCount,
  secDKCountAndUnqualifiedCount,
  initDKLeng,
  KWDKLeng,
  secDKLeng,
  initScanLengthRatio,
  KWScanLengthRatio,
  secScanLengthRatio,
  initUnqualifiedPoint,
  KWUnqualifiedPoint,
  secUnqualifiedPoint,
  projectLevelData,
  sectionLevelData,
  buildLevelData,
  initProjectSiteLevelData,
  KWProjectSiteLevelData,
  secProjectSiteLevelData,
  initPlcInfo,
  kaiwaPlcInfo,
  secPlcInfo,


  //断面详情
  initDKDetail,
  KWDKDetail,
  secDKDetail,
  initDKDetailPoints,
  KWDKDetailPoints,
  secDKDetailPoints,
  projectInfoById,
  projectSectionById,
  buildById,
  projectsiteById,
  initCloudPoint,
  kaiwaCloudPoint,
  secCloudPoint,
  //设备
  deviceAdd,
  deviceDelete,
  deviceEdit,
  deviceQuery,
  equipmentTypeList,
  checkRecordById,
  addNotFile,
  updateNotFile,

  //超欠挖
  KaiWaChaoQianWaData,
  initChaoQianWaData,
  secChaoQianWaData,
  initDKHandleCount,
  kaiWaDKHandleCount,
  secDKHandleCount,
  initDKHandleTime,
  kaiWaHandleTime,
  secDKHandleTime,
  initDkHandle,
  kaiwaDkHandle,
  secDkHandle,
  batchKaiWaDkHandle,
  batchInitDkHandle,
  batchSecDkHandle,
  batchKaiWaDkHandleClose,
  batchInitDkHandleClose,
  batchSecDkHandleClose,
  getInitFilesById,
  getKaiWaFilesById,
  getSecFilesById,
  initSectionPoint,
  kaiwaSectionPoint,
  secSectionPoint,
  chaoxianReviewList,
  sectionListByProjectIdAndUserId,

  //设置界面
  addKaiWaSetting,
  addInitSetting,
  addSecSetting,
  queryKaiWaPage,
  queryInitPage,
  querySecPage,
  updateKaiWaSetting,
  updateInitSetting,
  updateSecSetting,
  getUserByLoginAccount,
  projectsiteInfo,
  addInitSettingAndFile,
  addSecSettingAndFile,
  addKWSettingAndFile,
  initSettingFilesById,
  KWSettingFilesById,
  secSettingFilesById,
  updateInitSettingAndFile,

  deleteInitSettingFile,
  updateKaiWaSettingAndFile,
  updateSecSettingAndFile,
  deleteKWSettingFile,
  deleteSecSettingFile,
  settingReviewList,
  downloadInitSettingFilesById,


  //工程树
  getProjectinfoByUserId,
  getProjectSectionByUserId,
  getBuildList,
  getProjectSiteListById,
  buildByUserId,
  projectSiteByUserId,
  sectionListByProjectId,



  //用户角色
  roleByLoginAccount,
  projectAndSectionTree,
  getRoleList,
  userList,
  roleUpdate,
  setProjectAndSectionPer,
  userAdd,
  userListSuper,
  queryProjectSiteListByAdmin,
  getUserInfoById,
  users_tokenToUser,

  //消息
  homeMessage,

  //衬砌厚度阈值设置
  addkaiwaAndPenmaoSetting,
  addPenmaoAndChenqiSetting,
  getkaiwaAndPenmaoList,
  getPenmaoAndChenqiList,
  kaiwaAndPenmaoEdit,
  penmaoAndChenqiEdit,
  kaiwaAndPenmaoFileList,
  penmaoAndChenQiFileList,
  kaiwaAndPenmaoFileDelete,
  penmaoAndChenqiFileDelete,
  penmaoAndChenqiCheckList,
  kaiwaAndPenmaoCheckList,

  //衬砌厚度
  KWPMDKlength,
  KWPMUnqualifiedPoint,
  KWPMliningLevelDataForProject,
  KWPMliningLevelDataForSection,
  KWPMliningLevelDataForBuild,
  KWPMliningLevelDataForProjectSitePage,
  KWPMLevelDataForProjectSiteLine,

  PMCQDKlength,
  PMCQUnqualifiedPoint,
  PMCQliningLevelDataForProject,
  PMCQliningLevelDataForSection,
  PMCQliningLevelDataForBuild,
  PMCQliningLevelDataForProjectSitePage,
  PMCQLevelDataForProjectSiteLine,

  //处理衬砌厚度
  KWPMPointList,
  KWPMPointEdit,
  KWPMPointFileList,
  KWPMPointCheckList,

  PMCQPointList,
  PMCQPointFileList,
  PMCQPointEdit,
  PMCQPointCheckList,

  //衬砌厚度断面
  KWPMSurfaceDetail,
  KWPMSurfacePointList,
  PMCQSurfaceDetail,
  PMCQSurfacePointList,
  getCrbimuid,


  // 人员授权
  addAccount,
  authUserList,
  getPermissTree,
  getAccountResource,
  saveAccountResource,
  authUserDelete,

  //方量
  volume_queryProjectVolumePage,
  volume_queryProjectSectionVolumePage,
  volume_queryBuildVolumePage,
  volume_queryProjectSiteVolumePage,
  volume_compareTrend,
  volume_batchUpdate,
  volume_editVolume,
  volume_createChenqiNumber,

  // 平整度
  planeness_queryProjectPlanenessListPage,
  planeness_queryProjectSectionPlanenessListPage,
  planeness_queryBuildPlanenessListPage,
  planeness_queryProjectSitePlanenessListPage,
  planeness_queryProjectPlanenessScan,
  planeness_queryProjectSectionPlanenessScan,
  planeness_queryBuildPlanenessScan,
  users_login,


  // 数据导入
  batchImportProjectInfo,
  batchImportProjectSectionInfo,
  batchImportProjectSite,

  // 人员管理
  personList,
  personAdd,
  projectList,
  sectionList,
  buildList,
  siteList,
  assignedSiteList,
  assignSiteList,
  passwordReset,
  delectPerson,


  downloadCQSettingFilesById,
  downloadPMSettingFilesById,
  downloadChaoXianFilesById,

  // 平整度阈值
  planenessSetting_queryPlanenessSettingPage,
  planenessSetting_addPlanenessSettingAndFile,
  planenessSetting_updatePlanenessSetting,
  planenessSetting_getPlanenessSettingFilesById,
  planenessSetting_deleteInitSettingFile,

  // 平整度问题处理
  planenessProblem_queryPlanenessProblemPage,
  planenessProblem_planenessProblemHandle,
  planenessProblem_queryPlanenessProblemFileList,
  planenessProblem_deletePlanenessProblemFile,
  planenessProblem_queryPlanenessProblemReviewList,



  // 方量阈值
  volumeSetList,
  volumeSetDownload,
  volumeSetAdd,
  volumeSetFileAdd,
  volumeSetFileDelete,
  volumeSetFileList,
  volumeSetUpdate,
  volumeUpdateVolumeSetting,

  // 方量问题处理
  volumeProblemList,
  volumeProblemCheckList,
  volumeProblemHandle,
  volumeProblemFileList,
  volumeProblemFileDelete,
  volumeProblemDownload,

  // 阈值删除
  kaiwaAndPenmaoSetting_deleteKWAndPMSetting,
  penmaoAndChenqiSetting_deletePMAndCQSetting,
  Setting_deleteKaiWaSetting,
  Setting_deleteInitSetting,
  Setting_deleteSecSetting,
  volumeSetting_deleteVolumeSetting,
  planenessSetting_deletePlanenessSetting,

  //考核
  czPlanenessStatistics,
  getVolumeScanProgress,
  volumeCheckExportWord,
  cZPlanenessExportWord,
}



// WEBPACK FOOTER //
// ./src/common/api.js